import { convertDate } from "../utils";
import Progress from "./Progress";

export default function Cantiere({ cantiere }) {
  const inizioLavori = new Date(cantiere.inizio);
  const fineLavori = inizioLavori.setDate(
    inizioLavori.getDate() + cantiere.durata
  );
  return (
    <section
      className="col-span-2"
      aria-labelledby="applicant-information-title"
    >
      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h2
            id="applicant-information-title"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            Informazioni del Cantiere
          </h2>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
          <dl className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Responsabile (impresa)
              </dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.tecnico}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Project Manager (impresa)
              </dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.pm}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Direttore dei Lavori
              </dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.dl}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">CSE</dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.cse}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">CIG</dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.cig}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">CUP</dt>
              <dd className="mt-1 text-sm text-gray-900">{cantiere.cup}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Importo Lavori
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                € {cantiere.importo}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Oneri Sicurezza
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                € {cantiere.sicurezza}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Inizio Lavori
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                {convertDate(cantiere.inizio)}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Durata Lavori
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                {cantiere.durata} Giorni
              </dd>
            </div>
            <div className="col-span-2">
              <Progress duration={cantiere.durata} start={cantiere.inizio} />
            </div>
            <div className="col-span-2 flex">
              <span className="my-auto inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
                Il cantiere Procede secondo i tempi
              </span>
            </div>
            <div className="col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Fine stimata
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                {convertDate(fineLavori)}
              </dd>
            </div>

            <div className="col-span-2">
              <dt className="text-sm font-medium text-gray-500">Descrizione</dt>
              <dd className="mt-1 text-sm text-gray-900">
                {cantiere.descrizione}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
